import type {ReturnShipment} from '@myparcel-frontend/types';
import {usePublicSdk} from '@myparcel-frontend/sdk';
import {useMemoize} from '@vueuse/core';

const cache = new Map<string, Promise<ReturnShipment>>();

export const useReturnShipment = () => {
  // todo - add error handeling
  const createReturnShipment = async (referer: string): Promise<ReturnShipment> => {
    const {sdk} = usePublicSdk();

    // the `x-referer` is used to send data to the api and the order is important
    const response = await sdk.postReturnShipments({
      headers: {
        'x-referer': referer,
      },
    });

    return response[0];
  };

  const clearCache = () => {
    cache.clear();
  };

  // todo - add error handeling
  const getReturnShipment = useMemoize(
    async (hash: string): Promise<ReturnShipment> => {
      const {sdk} = usePublicSdk();
      const response = await sdk.getReturnShipment({
        path: {hash},
      });

      return response[0];
    },
    {
      cache,
    },
  );

  const createReturnLabel = (hash: string, email: string) => {
    const {sdk} = usePublicSdk();
    return sdk.postReturnShipmentLabel({
      body: [
        {
          hash,
          email,
        },
      ],
    });
  };

  return {
    createReturnShipment,
    getReturnShipment,
    createReturnLabel,
    clearCache,
  };
};
